export enum IncomingInvoiceListTabsEnum {
  PENDING = 'pending',
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  TEMPLATE = 'template',
  ALL = 'all',
}
